import { dataMember, required } from 'santee-dcts';
import { deserializers } from '../../core';
import * as moment from 'moment';

export class ExternalEQueryAccessionInfo {
    @dataMember()
    @required()
    public siteId: number;

    @dataMember()
    @required({nullable: true})
    public screeningNumber: string;

    @dataMember()
    @required({nullable: true})
    public subjectNumber: string;

    @dataMember()
    @required()
    public accessionId: number;

    @dataMember()
    @required({nullable: true})
    public accessionNumber: string;

    @dataMember()
    @required({nullable: true})
    public age: number;

    @dataMember()
    @required({nullable: true})
    public gender: string;

    @dataMember()
    @required({nullable: true})
    public visitName: string;

    @dataMember()
    @required({nullable: true})
    public protocolVisitCode: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({nullable: true})
    public patientDob: moment.Moment;

    @dataMember()
    @required({nullable: true})
    public patientInitials: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({nullable: true})
    public visitCollectionDateTime: moment.Moment;

    @dataMember()
    @required()
    public isAgeProject: boolean;

    @dataMember()
    @required({nullable: true})
    public protocolId: number;
}
